import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { GetCustomPlaceholdersRPC } from "./getCustomPlaceholdersRPC";

export class GetCustomPlaceholdersRPCClientImpl extends GetCustomPlaceholdersRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: GetCustomPlaceholdersRPC.Request): Promise<LeoRPCResult<GetCustomPlaceholdersRPC.Response, GetCustomPlaceholdersRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "email-cycle/GetCustomPlaceholders",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      GetCustomPlaceholdersRPC.ResponseDTO,
      GetCustomPlaceholdersRPC.Errors.ErrorsDTO,
      GetCustomPlaceholdersRPC.Response,
      GetCustomPlaceholdersRPC.Errors.Errors
    >(
      response,
      "email-cycle/GetCustomPlaceholders",
      GetCustomPlaceholdersRPC.Response.fromDTO,
      GetCustomPlaceholdersRPC.Errors.fromDTO
    );
  }
}
